import { render } from "./ElpLocallyWidget.vue?vue&type=template&id=8defe942"
import script from "./ElpLocallyWidget.vue?vue&type=script&lang=js"
export * from "./ElpLocallyWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__